import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instancebefxze3q9f64 as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.xv(parentContext.bd(Key_instance));
        }
        this.aw_1 = parentContext.pm(this);
      }
      pc() {
        return this.aw_1;
      }
      bw() {
        return this.aw_1;
      }
      cw() {
        return super.cw();
      }
      dw(value) {
      }
      ew(cause, handled) {
      }
      fw() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      gw(state) {
        if (state instanceof CompletedExceptionally()) {
          this.ew(state.hw_1, state.jw());
        } else {
          this.dw(state);
        }
      }
      rc(result) {
        var state = this.kw(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.lw(state);
      }
      lw(state) {
        return this.mw(state);
      }
      nw(exception) {
        handleCoroutineException(this.aw_1, exception);
      }
      ow() {
        var tmp0_elvis_lhs = get_coroutineName(this.aw_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.ow();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.ow();
      }
      pw(start, receiver, block) {
        start.sw(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
